/**
 * All Tools 页文案（稿面英文占位；产品定稿后可改）
 * Detector / MV 的 desc 与稿一致（暂复用 Act 描述）
 */
export default {
  pageTitle: "All Tools",
  pageSubtitle: "Explore all AI tools and unlock endless creative possibilities.",
  featuredSectionTitle: "Featured Tools",
  librarySectionTitle: "Tool Library",
  tabs: {
    all: "All",
    avatar: "Avatar",
    video: "Video",
    image: "Image",
    audio: "Audio",
  },
  featured: {
    avatarVideo: {
      title: "Avatar Video",
      subtitle: "Natural talking avatar",
    },
    aiVideo: {
      title: "AI Video",
      subtitle: "Video animations",
    },
    aiImage: {
      title: "AI Image",
      subtitle: "High quality images",
    },
    liveStudio: {
      title: "AI Live Studio",
      subtitle: "Lifelike live avatar",
    },
  },
  library: {
    watermark: {
      title: "Watermark Remover",
      desc: "Easily remove watermarks from your videos in seconds.",
    },
    aiFilter: {
      title: "AI Filter",
      desc: "Apply artistic and trending filters to give your photos a brand-new visual style.",
    },
    faceSwap: {
      title: "Face Swap",
      desc: "Swap faces in videos with smooth, realistic transitions in seconds.",
    },
    videoEnhance: {
      title: "Video Enhance",
      desc: "Improve video clarity, resolution, and details using AI upscaling.",
    },
    photoEnhance: {
      title: "Photo Enhance",
      desc: "Restore and sharpen low-quality images using smart enhancement tools.",
    },
    avatarBulk: {
      title: "Avatar Bulk",
      desc: "Generate multiple avatar videos at once - smart, natural, perfectly synced.",
    },
    voiceStudio: {
      title: "Voice Studio",
      desc: "Record or upload audio and turn it into professional-quality voiceovers.",
    },
    act: {
      title: "Act",
      desc: "Make avatars perform expressive actions by syncing motion to your script.",
    },
    petLipSync: {
      title: "Pet Lip Sync",
      desc: "Make your pets come alive by syncing their faces to human voices and dialogues.",
    },
    videoTranslator: {
      title: "Video Translator",
      desc: "Translate videos with top-tier quality and unbeatable prices for creators, ads, and etc.",
    },
    bgRemover: {
      title: "Background Remover",
      desc: "Quickly erase image backgrounds with precision - no manual work needed.",
    },
    dreamAvatar: {
      title: "Dream Avatar 3.0",
      desc: "Customize and generate unique AI avatars with full control over features.",
    },
    podcast: {
      title: "Podcast",
      desc: "Easily script, edit, and export podcasts powered by AI-generated avatars.",
    },
    lifetimeVideo: {
      title: "Lifetime Video",
      desc: "Create a video that shows a character's complete life journey across different stages of life.",
    },
    imageDetector: {
      title: "AI Image Detector",
      desc: "Make avatars perform expressive actions by syncing motion to your script.",
    },
    aiSound: {
      title: "AI Sound",
      desc: "Generate realistic sound effects, voices, and background audio in seconds.",
    },
    mv: {
      title: "Cinematic MV",
      desc: "Make avatars perform expressive actions by syncing motion to your script.",
    },
  },
};
